<template>
  <div>
    <div class="admininEnter" v-if="isLimit">
      <div class="form_item">
        <p class="label_item">设备编号：</p>
        <div class="codeNum">
          <input type="tel" placeholder="请输入或扫码填写设备编号" maxlength="10" v-model="barCode" />
          <img src="@/assets/images/scan.png" alt="" class="scanIMG" @click="scanCode" />
        </div>
      </div>
      <div class="addMachshine" @click="addMachshine"><van-icon name="plus" /> <span>添加</span></div>

      <div class="addMachshineWrap">
        <div class="machshine_item" v-for="(item, index) in machshineArr" :key="index">
          <span class="flex_left">{{ index + 1 }}</span>
          <div class="machshine_info">
            <p>
              <span>设备编号:</span> <span>{{ item }}</span>
            </p>
            <p><span>设备状态:</span> <span>物品闲置，没有人使用</span></p>
          </div>
          <van-icon name="cross" @click="removeMachshine(index)" />
        </div>
      </div>
      <!--    按钮-->
      <div class="button_group">
        <van-button class="backBtn" @click="backToPre">返回</van-button>
        <van-button @click="submitEnter">确认入库</van-button>
      </div>
    </div>
    <emptyPage :isLimit="isLimit" />
  </div>
</template>

<script>
import { assetsEnter } from "@/server/api";
import { Toast } from "vant";
import { wxConfig } from "@/views/fastReply/js/config";
import { pageLimit } from "@/utils/public";
import emptyPage from "@/components/emptyPage";

export default {
  name: "assetsEnter",
  data() {
    return {
      barCode: "",
      // cityId:'1',
      cityId: JSON.parse(localStorage.getItem("userInfo")).zsCityId + "", //当前登录者所属校区ID,
      machshineArr: [],
      allCityList: [],
      isLimit: "",
    };
  },
  components: { emptyPage },
  async mounted() {
    let that = this;
    await pageLimit("assents:add", function (bool) {
      that.isLimit = bool;
    });
    if (this.isLimit) {
      this.replyConfig();
    }
  },
  methods: {
    // 添加设备
    addMachshine() {
      if (this.barCode.length === 10) {
        this.machshineArr.push(this.barCode);
        this.barCode = "";
        this.machshineArr = [...new Set(this.machshineArr)];
      }
    },
    //删除
    removeMachshine(index) {
      this.machshineArr.splice(index, 1);
    },
    async submitEnter() {
      const { data: res } = await assetsEnter({
        cityId: this.cityId,
        assetsNos: this.machshineArr,
      });
      if (res.code != 200) return Toast.fail(res.msg);
      Toast.success("入库成功");
    },
    backToPre() {
      this.$router.go(-1);
    },
    replyConfig() {
      wxConfig(window.location.href.split("#")[0], ["scanQRCode"]);
    },
    scanCode() {
      let that = this;
      wx.scanQRCode({
        desc: "scanQRCode desc",
        needResult: 1, // 默认为0，扫描结果由企业微信处理，1则直接返回扫描结果，
        scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是条形码（一维码），默认二者都有
        success: function (res) {
          // 回调
          that.barCode = res.resultStr; //当needResult为1时返回处理结果
        },
        error: function (res) {
          if (res.errMsg.indexOf("function_not_exist") > 0) {
            alert("版本过低请升级");
          }
        },
      });
    },
  },
};
</script>

<style scoped lang="less">
.admininEnter {
  min-height: 100vh;
  padding: 19px 28px 0;
  background-color: #ffffff;
  .form_item {
    margin-bottom: 30px;
    &.flex_item {
      display: flex;
      align-items: center;
    }
    .label_item {
      font-size: 28px;
      color: #666666;
      margin-bottom: 16px;
    }
    .codeNum {
      position: relative;
      width: 100%;
      border: 1px solid #d8d8d8;
      padding: 20px 50px 20px 20px;
      input {
        font-size: 26px;
        outline: none;
        width: 90%;
      }
      .scanIMG {
        width: 40px;
        position: absolute;
        right: 20px;
        top: 16px;
      }
    }
  }
  .addMachshine {
    height: 88px;
    line-height: 88px;
    border-radius: 8px;
    font-size: 30px;
    color: #277fff;
    text-align: center;
    border: 1px solid #277fff;
  }
  .addMachshineWrap {
    margin-top: 60px;
    padding-bottom: 130px;
    .machshine_item {
      height: 124px;
      border-radius: 6px;
      border: 1px solid #d8d8d8;
      margin-bottom: 30px;
      display: flex;
      align-items: center;
      .flex_left {
        width: 76px;
        line-height: 84px;
        background-color: #f8f8f8;
        border-radius: 0 6px 6px 0;
        font-size: 28px;
        text-align: center;
      }
      .machshine_info {
        width: 79%;
        margin-left: 20px;
        p {
          font-size: 26px;
          margin-bottom: 7px;
          span:first-child {
            color: #666666;
          }
          span:last-child {
            color: #333333;
          }
        }
      }
      .van-icon {
        font-size: 30px;
        color: #bbbbbb;
      }
    }
  }
  .button_group {
    position: fixed;
    bottom: 0;
    padding: 25px 0;
    background-color: #ffffff;
    .van-button {
      width: 327px;
      font-size: 16px;
      border-radius: 8px;
      &:first-child {
        background-color: #f5f5f5;
        margin-right: 39px;
        color: #333333;
      }
      &:last-child {
        background-color: #277fff;
        color: #ffffff;
      }
    }
  }
}
</style>
